import { render, staticRenderFns } from "./DashBoardConfigurationGroup.vue?vue&type=template&id=f4fc2bd6&scoped=true"
import script from "./DashBoardConfigurationGroup.vue?vue&type=script&lang=js"
export * from "./DashBoardConfigurationGroup.vue?vue&type=script&lang=js"
import style0 from "./DashBoardConfigurationGroup.vue?vue&type=style&index=0&id=f4fc2bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fc2bd6",
  null
  
)

export default component.exports